/** App routes that must work without login (shared recording links, etc.). */
export function isPublicRecordingPath(pathname: string): boolean {
  return pathname === '/recording' || pathname.startsWith('/recording/')
}
